import React from 'react'
import { Page } from '../../components'
import { getString } from '@vrw/data'
import { DiscoveryFeed } from '@/components/DiscoveryFeed'

export const Spend = () => (
  <Page testId="page-spend" title="Spend Virgin Points | Virgin Red" metaDescription={getString('meta.description.spend')}>
    <DiscoveryFeed title={getString('discovery.header.title.spend')} isEarn={false} />
  </Page>
)
